import { trackError } from '@billy/track-error'
import { useCallback, useState } from 'react'

import { fetchZervantPortal } from '../query-api'

export const useOpenZervantPortal = () => {
  const [isLoading, setIsLoading] = useState(false)

  const openPortal = useCallback(async (flow?: string) => {
    setIsLoading(true)
    try {
      const response = await fetchZervantPortal(flow)
      window.open(response.data.url, '_blank', 'noopener,noreferrer')
    } catch (error) {
      trackError(error)
    } finally {
      setIsLoading(false)
    }
  }, [])

  return { openPortal, isLoading }
}
